import { defineMessages } from 'react-intl';

import TRAVEL_FEATURES from './TravelFeatures';


// used by experiment `cc-more-specific` to combine multiple features into one 'pseudo' feature
const COMBINATION_FEATURE = {
    baggageCombined: 'baggageCombined',
    tripCombined: 'tripCombined',
};

const FEATURE_COMBINATIONS = {
    [COMBINATION_FEATURE.baggageCombined]: [ TRAVEL_FEATURES.BAGGAGE_DELAY, TRAVEL_FEATURES.BAGGAGE_LOSS ],
    [COMBINATION_FEATURE.tripCombined]: [ TRAVEL_FEATURES.TRIP_CANCELLATION, TRAVEL_FEATURES.TRIP_INTERRUPTION ],
};


// The order here also determines the order in which these appear in checkboxes.
// The 'cf-feature-' prefix is a hangover from an earlier way of doing things that we no longer rely on.
const TRAVEL_FEATURE_MESSAGES = defineMessages({
    [TRAVEL_FEATURES.BAGGAGE_DELAY]: {
        id: 'cf-feature-Baggage delay',
        defaultMessage: 'Baggage delay insurance',
    },
    [TRAVEL_FEATURES.BAGGAGE_LOSS]: {
        id: 'cf-feature-Baggage loss',
        defaultMessage: 'Baggage loss insurance',
    },
    [COMBINATION_FEATURE.baggageCombined]: {
        id: 'cf-feature-Baggage-combined',
        defaultMessage: 'Baggage loss or delay',
    },

    [TRAVEL_FEATURES.CAR_RENTAL]: {
        id: 'cf-feature-Car rental collision / loss damage waiver',
        defaultMessage: 'Car rental insurance',
    },
    [TRAVEL_FEATURES.EXTENDED_WARRANTY]: {
        id: 'cf-feature-Extended warranty',
        defaultMessage: 'Extended warranty',
    },
    [TRAVEL_FEATURES.FLIGHT_DELAY]: {
        id: 'cf-feature-Flight delay',
        defaultMessage: 'Flight delay insurance',
    },
    [TRAVEL_FEATURES.LOUNGE_ACCESS]: {
        id: 'cf-feature-Lounge access',
        defaultMessage: 'Lounge access',
    },
    [TRAVEL_FEATURES.MOBILE_INSURANCE]: {
        id: 'cf-feature-Mobile insurance',
        defaultMessage: 'Mobile insurance',
    },
    [TRAVEL_FEATURES.NO_FOREX]: {
        id: 'cf-feature-No foreign exchange fees',
        defaultMessage: 'Waived foreign transaction fees',
    },
    [TRAVEL_FEATURES.PRICE_PROTECTION]: {
        id: 'cf-feature-Price protection',
        defaultMessage: 'Price protection',
    },
    [TRAVEL_FEATURES.PURCHASE_ASSURANCE]: {
        id: 'cf-feature-Purchase assurance',
        defaultMessage: 'Purchase assurance',
    },
    [TRAVEL_FEATURES.TRAVEL_ACCIDENT]: {
        id: 'cf-feature-Travel accident insurance',
        defaultMessage: 'Travel accident insurance',
    },
    [TRAVEL_FEATURES.TRAVEL_EMERGENCY]: {
        id: 'cf-feature-Travel emergency medical',
        defaultMessage: 'Travel emergency medical',
    },

    [TRAVEL_FEATURES.TRIP_CANCELLATION]: {
        id: 'cf-feature-Trip cancellation',
        defaultMessage: 'Trip cancellation',
    },
    [TRAVEL_FEATURES.TRIP_INTERRUPTION]: {
        id: 'cf-feature-Trip interruption',
        defaultMessage: 'Trip interruption',
    },
    [COMBINATION_FEATURE.tripCombined]: {
        id: 'cf-feature-Trip-combined',
        defaultMessage: 'Trip cancellation or interruption',
    },

    [TRAVEL_FEATURES.HOTEL_MOTEL_BURGLARY]: {
        id: 'cf-feature-Hotel/motel burglary',
        defaultMessage: 'Hotel/motel burglary',
    },
});


const TRAVEL_FEATURE_OPTIONS = Object.keys(TRAVEL_FEATURE_MESSAGES).map(value => ({
    value: value,
    label: TRAVEL_FEATURE_MESSAGES[value],
}));


export { COMBINATION_FEATURE, FEATURE_COMBINATIONS };
export default TRAVEL_FEATURE_OPTIONS;
